import { type ComponentProps } from 'react';

import { type LocationSearchService } from '../../../../machine';
import { LocationResultsCard } from '../../../LocationResults/subcomponents';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationGroupCard = (props: Props) => {
  const { location, interactedLocationRestaurantSlug, isLoading, ...restProps } = props;

  const { restaurantSlug } = location;

  // ─── Flags ───────────────────────────────────────────────────────────

  const isInteracted =
    interactedLocationRestaurantSlug !== undefined &&
    restaurantSlug !== undefined &&
    interactedLocationRestaurantSlug === restaurantSlug;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <LocationResultsCard
      location={location}
      withDetailsModal
      isLoading={isInteracted || isLoading}
      isDisabled={isInteracted || isLoading}
      {...restProps}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  locationSearchService: LocationSearchService; // prettier-ignore
  interactedLocationRestaurantSlug: string | undefined;
} & LocationResultCardProps;

type LocationResultCardProps = Omit<ComponentProps<typeof LocationResultsCard>, 'isDisabled'>;
